export interface Actor {
  id: string;
  name: string;
  initial: string;
  role: string;
  roleType: string;
  avatar: string;
  shortBio: string;
  bio: string;
  episodeIds: string[];
  articleIds: string[];
}

export const actors: Actor[] = [
  {
    id: "actor-1",
    name: "周雨彤",
    initial: "Z",
    role: "林晓",
    roleType: "主角",
    avatar:
      "https://readdy.ai/api/search-image?query=Studio%20portrait%20of%20a%20calm%20young%20Chinese%20woman%20in%20a%20soft%20cream%20knit%20top%2C%20gentle%20confident%20expression%2C%20warm%20neutral%20beige%20seamless%20background%2C%20soft%20directional%20lighting%2C%20editorial%20headshot%20photography%2C%20high%20detail%2C%20natural%20skin%20tones%2C%20cinematic%20color%20grading&width=600&height=600&seq=nm1-actor-01&orientation=squarish",
    shortBio: "饰演女主林晓。从青涩新手妈妈到独立女性的完整弧光，是这部剧的情感核心。",
    bio: "周雨彤在剧中饰演女主林晓。为了贴近角色产后状态的疲惫与坚韧，她在开拍前特意增重并剪短了头发。她表示，林晓身上最打动她的，是那种‘明明在崩溃边缘，却还是会把奶瓶消毒好’的普通人的坚强。剧中大量情绪特写几乎都由她一条过完成，导演称赞她‘把沉默演出了声音’。",
    episodeIds: ["ep-1", "ep-2", "ep-3", "ep-6", "ep-8", "ep-12"],
    articleIds: ["plot-1", "plot-2", "plot-5"],
  },
  {
    id: "actor-2",
    name: "李铭远",
    initial: "L",
    role: "陈默",
    roleType: "主角",
    avatar:
      "https://readdy.ai/api/search-image?query=Studio%20portrait%20of%20a%20thoughtful%20young%20Chinese%20man%20in%20a%20simple%20grey%20shirt%2C%20slightly%20tired%20honest%20expression%2C%20warm%20neutral%20beige%20seamless%20background%2C%20soft%20directional%20lighting%2C%20editorial%20headshot%20photography%2C%20high%20detail%2C%20natural%20skin%20tones%2C%20cinematic%20color%20grading&width=600&height=600&seq=nm1-actor-02&orientation=squarish",
    shortBio: "饰演丈夫陈默。一个并不完美、却在慢慢学会承担的普通男人。",
    bio: "李铭远饰演的林晓丈夫陈默，是全剧争议最大的角色之一。他坦言自己在看剧本时也曾‘恨’过这个角色，但正是这种不回避缺点的人物，才更接近现实中的大多数伴侣。为了演好一个笨拙但善良的丈夫，他特意观察了身边新手爸爸的手足无措。",
    episodeIds: ["ep-1", "ep-4", "ep-9", "ep-11", "ep-12"],
    articleIds: ["plot-3", "plot-4"],
  },
  {
    id: "actor-3",
    name: "王丽华",
    initial: "W",
    role: "张桂兰",
    roleType: "配角",
    avatar:
      "https://readdy.ai/api/search-image?query=Studio%20portrait%20of%20a%20dignified%20older%20Chinese%20woman%20with%20neat%20grey%20hair%20in%20a%20deep%20maroon%20blouse%2C%20warm%20reserved%20expression%2C%20warm%20neutral%20beige%20seamless%20background%2C%20soft%20directional%20lighting%2C%20editorial%20headshot%20photography%2C%20high%20detail%2C%20cinematic%20color%20grading&width=600&height=600&seq=nm1-actor-03&orientation=squarish",
    shortBio: "饰演婆婆张桂兰。强势的外表下，藏着一代女性的隐忍与伤痛。",
    bio: "王丽华饰演的婆婆张桂兰，前期几乎承担了全部观众怒意，后期却凭一场翻看旧相册的戏彻底翻盘。这位从业三十余年的老戏骨表示，她不想把婆婆演成脸谱化的‘恶’，而是希望观众看到她被生活磨损的那一面。",
    episodeIds: ["ep-2", "ep-4", "ep-8", "ep-12"],
    articleIds: ["plot-1", "plot-6"],
  },
  {
    id: "actor-4",
    name: "苏晴",
    initial: "S",
    role: "苏雅",
    roleType: "配角",
    avatar:
      "https://readdy.ai/api/search-image?query=Studio%20portrait%20of%20a%20bright%20cheerful%20young%20Chinese%20woman%20with%20long%20wavy%20hair%20in%20a%20soft%20pink%20blouse%2C%20warm%20friendly%20smile%2C%20warm%20neutral%20beige%20seamless%20background%2C%20soft%20directional%20lighting%2C%20editorial%20headshot%20photography%2C%20high%20detail%2C%20cinematic%20color%20grading&width=600&height=600&seq=nm1-actor-04&orientation=squarish",
    shortBio: "饰演林晓闺蜜苏雅。在主角最灰暗的时刻，递来一束光。",
    bio: "苏晴饰演的苏雅，是林晓婚后几乎唯一的情感出口。她把这个角色演出了‘闺蜜感’——不劝、不评判，只是安静地坐在你旁边。她与周雨彤的大量即兴对手戏，被不少观众认为是全剧最松弛自然的段落。",
    episodeIds: ["ep-3", "ep-5", "ep-7"],
    articleIds: ["plot-2", "plot-5"],
  },
  {
    id: "actor-5",
    name: "赵天宇",
    initial: "Z",
    role: "陆晨",
    roleType: "配角",
    avatar:
      "https://readdy.ai/api/search-image?query=Studio%20portrait%20of%20a%20clean%20cut%20young%20Chinese%20man%20in%20a%20navy%20shirt%2C%20calm%20sincere%20expression%2C%20warm%20neutral%20beige%20seamless%20background%2C%20soft%20directional%20lighting%2C%20editorial%20headshot%20photography%2C%20high%20detail%2C%20natural%20skin%20tones%2C%20cinematic%20color%20grading&width=600&height=600&seq=nm1-actor-05&orientation=squarish",
    shortBio: "饰演合作人陆晨。工作伙伴，也是林晓重新出发路上的见证者。",
    bio: "赵天宇饰演的陆晨是林晓自由职业路上的第一个合作方。他克制、专业，与林晓之间始终保持着恰到好处的分寸感。这个角色没有落入‘男二插足’的俗套，反而成了剧中少见的清爽职场关系。",
    episodeIds: ["ep-7", "ep-10", "ep-11"],
    articleIds: ["plot-5"],
  },
  {
    id: "actor-6",
    name: "陈静怡",
    initial: "C",
    role: "林母",
    roleType: "配角",
    avatar:
      "https://readdy.ai/api/search-image?query=Studio%20portrait%20of%20a%20kind%20older%20Chinese%20woman%20with%20short%20curly%20hair%20in%20a%20light%20blue%20cardigan%2C%20gentle%20understanding%20expression%2C%20warm%20neutral%20beige%20seamless%20background%2C%20soft%20directional%20lighting%2C%20editorial%20headshot%20photography%2C%20high%20detail%2C%20cinematic%20color%20grading&width=600&height=600&seq=nm1-actor-06&orientation=squarish",
    shortBio: "饰演林晓母亲。戏份不多，却是女主性格的来处。",
    bio: "陈静怡饰演的林晓母亲，是一位远在南方小城、不善言辞的母亲。她的每一次电话、每一句‘你还好吗’，都给林晓留了一条回家的路。这条母女线虽然克制，却是全剧最柔软的部分。",
    episodeIds: ["ep-1", "ep-6", "ep-12"],
    articleIds: ["plot-2", "plot-6"],
  },
  {
    id: "actor-7",
    name: "何俊杰",
    initial: "H",
    role: "王强",
    roleType: "配角",
    avatar:
      "https://readdy.ai/api/search-image?query=Studio%20portrait%20of%20a%20sturdy%20middle%20aged%20Chinese%20man%20in%20a%20checked%20shirt%2C%20blunt%20practical%20expression%2C%20warm%20neutral%20beige%20seamless%20background%2C%20soft%20directional%20lighting%2C%20editorial%20headshot%20photography%2C%20high%20detail%2C%20cinematic%20color%20grading&width=600&height=600&seq=nm1-actor-07&orientation=squarish",
    shortBio: "饰演陈默父亲王强。沉默寡言，用行动代替语言的一代人。",
    bio: "何俊杰饰演的陈默父亲，是家中最沉默的那个人。他不懂表达，却在关键时刻拎着行李站在儿子家门口。他的存在，解释了陈默笨拙温柔的性格来源。",
    episodeIds: ["ep-4", "ep-9", "ep-12"],
    articleIds: ["plot-4"],
  },
  {
    id: "actor-8",
    name: "吴梦洁",
    initial: "W",
    role: "阿香",
    roleType: "配角",
    avatar:
      "https://readdy.ai/api/search-image?query=Studio%20portrait%20of%20a%20gentle%20young%20Chinese%20woman%20with%20hair%20tied%20back%20in%20a%20plain%20grey%20top%2C%20modest%20warm%20expression%2C%20warm%20neutral%20beige%20seamless%20background%2C%20soft%20directional%20lighting%2C%20editorial%20headshot%20photography%2C%20high%20detail%2C%20cinematic%20color%20grading&width=600&height=600&seq=nm1-actor-08&orientation=squarish",
    shortBio: "饰演家中保姆阿香。一个旁观者，也是一面镜子。",
    bio: "吴梦洁饰演的阿香是林晓家请来的帮手，来自小城，做事利落。她的到来缓解了林晓的疲惫，也带来了新的家庭关系课题。这个角色用旁观的视角，映照出这个家的真实温度。",
    episodeIds: ["ep-3", "ep-10"],
    articleIds: ["plot-3"],
  },
];